module.exports = __webpack_public_path__ + "static/media/offline-pin.33793a06.svg";